export default {
    data () {
        return {
            headers: {
                Authorization: localStorage.getItem('Authorization')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js